// src/api/helpdeskRules.js
import api from "./api";

export const HelpdeskRulesAPI = {
  list: () => api("/helpdesk/admin/rules"),

  get: (id) => api(`/helpdesk/admin/rules/${id}`),

  create: (data) =>
    api("/helpdesk/admin/rules", {
      method: "POST",
      body: JSON.stringify(data),
    }),

  update: (id, data) =>
    api(`/helpdesk/admin/rules/${id}`, {
      method: "PUT",
      body: JSON.stringify(data),
    }),

  enable: (id) =>
    api(`/helpdesk/admin/rules/${id}/enable`, {
      method: "POST",
    }),

  disable: (id) =>
    api(`/helpdesk/admin/rules/${id}/disable`, {
      method: "POST",
    }),

  delete: (id) =>
    api(`/helpdesk/admin/rules/${id}`, {
      method: "DELETE",
    }),

  listNotifications: () => api("/helpdesk/admin/notifications"),

  // trigger dropdown
  listEvents: () => api("/helpdesk/admin/rules/events"),

  // fields dropdown
  listFields: () => api("/helpdesk/admin/rules/fields"),

  listLifecycleOptions: () => api("/helpdesk/admin/rules/options/lifecycle"),

  listOperators: () => api("/helpdesk/admin/rules/operators"),

  testRule: (payload) =>
    api("/helpdesk/admin/rules/test", {
      method: "POST",
      body: JSON.stringify(payload),
    }),

    listCategoryOptions: () =>
      api("/helpdesk/admin/rules/options/categories"),

    listDepartmentOptions: () =>
      api("/helpdesk/admin/rules/options/departments"),

    listPriorityOptions: () =>
      api("/helpdesk/admin/rules/options/priorities"),

    listStatusOptions: () =>
      api("/helpdesk/admin/rules/options/statuses"),

    listSchoolOptions: () =>
      api("/helpdesk/admin/rules/options/schools"),

    listSubcategoryOptions: () =>
      api("/helpdesk/admin/rules/options/subcategories"),

    listUsers: () =>
      api("/helpdesk/admin/users"),
};